module.exports = __webpack_public_path__ + "static/media/icon_instrument_saxophone.70f75431.svg";